import { OnboardingResponseStatus } from 'clickNgo/configs/service/onboarding'
import { IContact } from 'clickNgo/entities/contact'
import { validateContact } from 'clickNgo/entities/contact/api'
import { IPartner } from 'clickNgo/entities/partner/models'
import {
  checkTargetPartnerCountryMatchContactCountry,
  checkTargetPartnerInHierarchy,
} from 'clickNgo/features/contact/contactRelinking/lib'
import { getJSendErrorMessages } from 'clickNgo/helpers/api'
import Logger from 'core/utils/Logger'

import { contactEditorTranslation } from '../../../../translation'

export const checkCriticalRelinkingPoints = async (partner: IPartner, contact: IContact) => {
  const validateAsyncResult = await validateContact({
    contactId: contact.contactId,
    email: contact.email,
    partnerId: partner.topPartnerId,
    country: partner.country,
  })

  const isTargetPartnerCountryMatchContactCountry = checkTargetPartnerCountryMatchContactCountry({
    partnerCountryCode: partner.countryCode,
    contactCountryCode: contact.countryOfBusiness,
  })

  if (!isTargetPartnerCountryMatchContactCountry) {
    Logger.info('The contact’s country does not match the country of the target partner')
    return contactEditorTranslation.relinkingFastCheck.countriesNotMatch
  } else if (validateAsyncResult.status === OnboardingResponseStatus.Fail) {
    Logger.info(
      'The contact’s email domain does not match the website domain of the target partner'
    )
    return getJSendErrorMessages(validateAsyncResult).join(', ')
  } else if (validateAsyncResult.status === OnboardingResponseStatus.Error) {
    Logger.info(
      'The contact’s email domain does not match the website domain of the target partner'
    )
    return validateAsyncResult.message
  }
  return null
}
